
export const SET_MSG = 'RELATORIO_DECIMO_MSG';
export const SET_EDITAR = 'RELATORIO_DECIMO_EDITAR';
export const SET_LISTA = 'RELATORIO_DECIMO_LISTA';
export const SET_ID = 'RELATORIO_DECIMO_ID';
export const SET_TRABALHADOR = 'RELATORIO_DECIMO_TRABALHADOR';